import { jsx } from 'react/jsx-runtime';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-header-brand-logo.css';
import { a as analyticsTracker } from '../analytics-tracker/index-chunk.esm.js';

const getClassNameList = classNames.bind(styles);
const EGDSHeaderBrandLogo = (props) => {
    const { imgSrc, href, altText, analytics } = props;
    // Tests have been written for this code, but it's still showing as uncovered, so we're ignoring it for the coverage.
    /* istanbul ignore next */
    return (jsx("a", { className: getClassNameList('uitk-header-brand-logo'), href: href || '/', "data-testid": "header-brand-logo-anchor", onClickCapture: analytics && analyticsTracker.bind(undefined, analytics), children: jsx("img", { src: imgSrc, alt: altText }) }));
};
EGDSHeaderBrandLogo.displayName = 'EGDSHeaderBrandLogo';

export { EGDSHeaderBrandLogo as E };
//# sourceMappingURL=index-chunk.esm.js.map
